import React from "react";
import { HyperLinkTypography, StyledTableCell } from "../style";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Box, styled } from "@mui/material";

const InnerCell = styled(Box)`
  display: flex;
  gap: 5px;
  cursor: pointer;
  width: 100%;
  position: relative;
`;

export default function Link(args) {
  if (typeof args.content !== "string") return <StyledTableCell {...args} />;
  const handleClick = () => window.open(`https://${args.content}`, "_blank");

  return (
    <StyledTableCell {...args}>
      <InnerCell onClick={handleClick}>
        <HyperLinkTypography variant="body2">
          {args.content}
        </HyperLinkTypography>
        <ArrowOutwardIcon fontSize="small" />
      </InnerCell>
    </StyledTableCell>
  );
}
